import { render } from "./SLink.vue?vue&type=template&id=30d39ac4&ts=true"
import script from "./SLink.vue?vue&type=script&lang=ts"
export * from "./SLink.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__